import { RxCollectionCreator } from 'rxdb';

export const adoptedSchema: RxCollectionCreator = {
	schema: {
		title: 'adopted schema',
		description: 'create a test schema',
		version: 4,
		primaryKey: 'sfid',
		type: 'object',
		properties: {
			id: {
				type: 'number',
			},
			sfid: {
				type: 'string',
				maxLength: 250,
			},
			phone: {
				type: 'string',
			},
			is_a_ob: {
				type: 'boolean',
			},
			name: {
				type: 'string',
			},
			status: {
				type: ['string', 'null'],
				default: null,
			},
			createddate: {
				type: 'string',
				format: 'date-time',
			},
			verification_status: {
				type: ['string', 'null'],
				default: null,
			},
			clubname: {
				type: 'string',
			},
			contractorclass: {
				type: 'string',
			},
			competitionconsumption: {
				type: 'number',
			},
			glue_consumption_per_month: {
				type: 'number',
			},
			priority: {
				type: ['string', 'null'],
				default: null,
			},
			totalbankingQTD: {
				type: ['number', 'null'],
				default: null,
			},
			visitstatus: {
				type: ['string', 'null'],
				default: null,
			},
			dateofvisit: {
				type: ['string', 'null'],
				format: 'date-time',
				default: null,
			},
			pwg_banking_qtd: {
				type: ['number', 'null'],
				default: null,
			},
			membershipno: {
				type: 'string',
			},
			currenttier: {
				type: 'string',
			},
			contractorconsumption: {
				type: ['string', 'null'],
				default: null,
			},
			lastactivitydate: {
				type: ['string', 'null'],
				format: 'date-time',
				default: null,
			},
			kyc_id_proof_verification: {
				type: 'string',
			},
			banking_six_month_kgs: {
				type: ['number', 'null'],
				default: null,
			},
			total_points_per_kgs: {
				type: ['number', 'null'],
				default: null,
			},
			banking_points_qtd: {
				type: ['number', 'null'],
				default: null,
			},

			club_mapping: {
				type: 'string',
			},
			is_zbc: {
				type: 'boolean',
			},
			is_de_growing: {
				type: 'boolean',
			},
			clustercode_c: {
				type: 'string',
			},
			clustername_c: {
				type: 'string',
			},
			is_disengaged_contractor: {
				type: 'boolean',
			},
			current_quarter_visitstatus: {
				type: 'boolean',
			},
			source_c: {
				type: ['string', 'null'],
				default: null,
			},
		},
		required: [
			'id',
			'sfid',
			'phone',
			'is_a_ob',
			'name',
			'createddate',
			'clubname',
			'contractorclass',
			'competitionconsumption',
			'glue_consumption_per_month',
			'membershipno',
			'currenttier',
			'kyc_id_proof_verification',
		],
	},
	migrationStrategies: {
		1: async (oldDoc) => {
			return {
				contractorconsumption: oldDoc.competition_brand_1_used,
				kyc_id_proof_verification: oldDoc.is_kyc_verified_c,
				...oldDoc,
			};
		},
		2: async (oldDoc) => {
			return {
				...oldDoc,
			};
		},
		3: async (oldDoc) => {
			return {
				...oldDoc,
			};
		},
		4: async (oldDoc) => {
			return {
				...oldDoc,
				source_c: oldDoc.source_c || null,
			};
		},
	},
};
